var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-no-permission"},[_c('base-result',{attrs:{"status":"403","sub-title":"抱歉,你无权访问此页面.","title":"403"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClick}},[_vm._v("\n      回首页\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }